<template>
  <div>
    <div id="overBg" :style="{ backgroundImage: `url( ${  this.getImg })` }"
         style="background-size: cover; background-repeat: no-repeat">
      <div style="background-color: rgba(3, 56, 96, 0.8)">
        <div class="uk-container">
          <div id="mainCaro" class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1"
               uk-slideshow="ratio: 3:1; animation: fade; autoplay: true; autoplay-interval: 10000">

            <ul class="uk-slideshow-items">
              <li v-for="(i, index) in this.loadBanners" :key="index">
<!--https://manage.ncu.edu.jm/wp-json/data/web-banners-->
                <img :src="i.acf.image" alt="" uk-cover
                     @click="openNewTab(i.acf.click_url)" v-if="i.acf.click_url !== ''">
                <img :src="i.acf.image" alt="" uk-cover v-else>
                <!--<div class="uk-position-medium uk-position-bottom-left uk-overlay uk-overlay-default" style="background-color: rgba(255, 215, 3, 0.6); color: #000;">
                    <h4 class="uk-text-left" style=" color: #000; font-weight: bolder">Alkaline Water</h4>
                    <p style="margin-top: -10px">
                        This is of a PH of 7 and above
                    </p>
                </div>-->

              </li>
              <!--<li>
                <img src="../../assets/bg.jpg" alt="" uk-cover>
              </li>-->
            </ul>

            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous
               uk-slideshow-item="previous"></a>
            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next
               uk-slideshow-item="next"></a>

          </div>
        </div>
      </div>
    </div>

    <!--Modal-->
    <!--      <div id="modal1" uk-modal>
            <div class="uk-modal-dialog uk-modal-body">
              <img src="../../assets/ClosureNoticeUpdated.jpg"/>
              <p class="uk-text-right">
                <button class="uk-button uk-button-primary uk-modal-close" type="button" style="background-color: #033860; color: #ffcb05; font-weight: bold">Close</button>
              </p>
            </div>
          </div>-->
  </div>
</template>

<script>
import UIkit from 'uikit'
import $ from 'jquery'

export default {
  name: "carousel",
  data() {
    return {
      image: '',
      img: this.loadBanners
    }
  },
  methods: {
    openNewTab(x) {
      window.open(x, '_blank');
    }
  },
  computed: {
    getImg() {
      return this.image
    },

    loadBanners: function () {
      /*for (let i = 0; i < this.$store.state.WebBannersList.length; i++){
          this.img.push(this.$store.state.WebBannersList[i].webBannerImage)
      }*/
      //console.log(this.$store.state.WebBannersList)

      return this.$store.state.WebBannersList
    }
  },
  mounted() {
    this.$store.commit('getBanners')
    let self = this
    UIkit.util.on(document, 'itemshow', '#mainCaro', function (e) {
      let x = $(e.target.innerHTML).attr('src')
      /* console.log(x);*/
      let ur = x.replace("\\", "/")
      let y = x.split('\\')
      /*console.log(y)*/
      self.image = /*'http://cmsapi.ncu.edu.jm/uploads/' +*/ y[1];
      document.getElementById("overBg").style.backgroundImage = "url('" + ur + "')";
    });
    //UIkit.modal('#modal1').show();

  }

}
</script>

<style scoped>

</style>
